import { useMemo } from 'react';
import { useQueryUserOptions } from '@arc/frontend/util-users';
import { MultiselectWithControl } from '../Multiselect';
export function SelectorUsersWithControlExclude({
  excludeUserIds = [],
  ...multiselectWithControlProps
}) {
  const {
    data,
    isPending
  } = useQueryUserOptions();
  const userList = data?.items;
  const filteredUsers = useMemo(() => {
    return userList?.filter(user => !excludeUserIds.includes(user.id)) ?? [];
  }, [userList, excludeUserIds]);
  return <MultiselectWithControl {...multiselectWithControlProps} options={filteredUsers} isLoading={isPending} getOptionLabel={option => option.name} isOptionEqualToValue={(option, value) => option.id === value.id} />;
}